<template>
  <el-dialog
    top="15vh"
    class="product-edit__dialog"
    :title="row ? $t('Common.edit') : $t('Common.create')"
    width="900px"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="visible"
  >
    <div class="el-form-item is-required el-form-item--small">
      <div class="el-form-item__label" style="width: 110px;">
        <el-tooltip class="item" effect="dark" placement="right-start" :visible-arrow="false">
          <span>
            {{ $t('Product.productFuncType') }}
            <svg class="icon">
              <use xlink:href="#icon-question1"></use></svg
          ></span>
          <template slot="content">
            {{ $t('Product.propertyDef') }}<br />
            {{ $t('Product.serviceDef') }}<br />
            {{ $t('Product.eventDef') }}
          </template>
        </el-tooltip>
      </div>
      <div class="el-form-item__content" style="margin-left: 110px;">
        <el-radio-group v-model="functionType">
          <el-radio label="property">{{ $t('Product.property') }}</el-radio>
          <el-radio label="service">{{ $t('Product.service') }}</el-radio>
          <el-radio label="event">{{ $t('Product.event') }}</el-radio>
        </el-radio-group>
      </div>
    </div>
    <PropertyForm
      v-if="functionType === 'property'"
      :isEdit="!!row"
      :identifier="identifier"
      @close="close"
      @refresh="refresh"
      v-bind="$attrs"
    />
    <ServiceForm
      v-if="functionType === 'service'"
      :isEdit="!!row"
      :identifier="identifier"
      @close="close"
      @refresh="refresh"
      v-bind="$attrs"
    />
    <EventForm
      v-if="functionType === 'event'"
      :isEdit="!!row"
      :identifier="identifier"
      @close="close"
      @refresh="refresh"
      v-bind="$attrs"
    />
  </el-dialog>
</template>

<script>
import PropertyForm from './PropertyForm'
import ServiceForm from './ServiceForm'
import EventForm from './EventForm'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    row: {
      type: Object
    }
  },
  components: {
    PropertyForm,
    ServiceForm,
    EventForm
  },
  data() {
    return {
      functionType: 'property'
    }
  },
  created() {
    if (this.row) {
      this.functionType = this.row.type
    }
  },
  computed: {
    identifier() {
      return this.row && this.row.identifier
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    refresh() {
      this.$emit('refresh')
    },
    checkForm(callback) {
      let pass
      this.$refs.form.validate((valid) => {
        pass = valid
        if (!valid) return
        callback && callback()
      })
      return pass
    }
  }
}
</script>
<style lang="scss">
.product-edit__dialog {
  .icon {
    color: $--color-blue;
    font-size: 16px;
    cursor: pointer;
  }
}
</style>
